import React, { useEffect, useState, useRef, useCallback } from "react";
import "../Distributor/Distributor.css";
import logo from "../../assets/images/logo.png";
import btnPrint from "../../assets/images/button_print.gif";
import xlsx from "../../assets/images/ico_xls_sm.gif";
import { Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getProductType } from "../../redux/actions/productType.action";
import { ReadCookie } from "../../utils/readCookie";
import {
  Spin,
  Select,
  DatePicker,
  Checkbox,
  Form,
  Input,
  Upload,
  message,
  Tooltip,
  Modal,
  Table,
} from "antd";
import { getStyle } from "../../redux/actions/style";
import { getGenderCategory } from "../../redux/actions/genderCategory.action";
import { getNewSeason } from "../../redux/actions/newSeason.action";
import { getProductStatus } from "../../redux/actions/productStatus.actions";
import { getAdminLocation } from "../../redux/actions/adminLocation.action";
import moment from "moment";
import { useDownloadExcel } from "react-export-table-to-excel";
import { getSaleOrderFormData } from "../../redux/actions/salesOrder.action";
import Loader from "react-loader-spinner";
import { getRegion } from "../../redux/actions/region.action";
import { getGender } from "../../redux/actions/gender.action";
import { getSeason } from "../../redux/actions/season.action";
import { getStyleBookedReport } from "../../redux/actions/bookedStyleWise.action";
import { getMonthWiseAvailability, getStylePendingReportWithAvailability } from "../../redux/actions/pendingStyleWise.action";
import { loadSalePerson } from "../../redux/actions/salePerson/salePersonForm.action";
import { TabTitle } from "../../utils/GeneralFunction";
import numeral from "numeral";
import { getCustomerType } from "../../redux/actions/customerType.action";
import { UploadOutlined, DownloadOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";
import { CloseCircleOutlined } from "@ant-design/icons";
import axios from "axios";
import { BASEURL } from "../../constant/config";
import ScheduleModal from "../../components/ScheduleModal/ScheduleModal";
import { getRights } from "../../redux/actions/userRights.action";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

const MonthWiseAvailability = ({ token }) => {
  TabTitle("Month Wise Availability");
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const {
    style,
    gender,
    adminLocation,
    getNewSeasonReducer,
    saleOrderFormData,
    region,
    season,
    monthWiseAvailability,
    salePerson,
    customerTypes,
  } = useSelector((state) => state);
  const menuId = ReadCookie("menuId");
  const userName = ReadCookie("name");
  const company_id = ReadCookie("defaultCompany");
  const [BGradechecked, setBGradeChecked] = useState(false);
  const [pendingDate, setpendingDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [checked, setChecked] = useState(true);
  const [uploaded, setUploaded] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpen1, setIsModalOpen1] = useState(false);
  const [formDisabled, setFormDisabled] = useState(false);

  const [isChecked, setIsChecked] = useState([]);
  const [pendingOrders, setPendingOrders] = useState([]);
  const [dummyData, setDummyData] = useState([]);

  const [allSesion, setAllSesion] = useState(true);

  const [steps, setSteps] = useState([]);
  const stepsArr = [1, 17, 18, 25, 2, 29];
  const [pendingChecked, setPendingChecked] = useState(true);
  const [scheduleData, setScheduleData] = useState({});
  const [userRights, setUserRights] = useState(false);
  const [isSort, setIsSort] = useState(false);

  const dateFormat = "MM-DD-YYYY";

  const tableRef = useRef(null);

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "Month Wise Availability",
    sheet: "Month Wise Availability",
  });

  useEffect(() => {
    if (!token || !menuId) return;

    dispatch(getRights(token, menuId)).then((res) => {
      if (res?.type === "GET_USER_RIGHTS_SUCCESS") {
        setUserRights(res?.payload?.can_add ?? false);
      } else {
        setUserRights(false);
      }
    });
  }, [dispatch, menuId, token]);

  useEffect(() => {
    if (adminLocation?.payload?.data?.length > 0) {
      setSteps(
        adminLocation?.payload?.data
          .filter((val) => stepsArr.includes(val.location_id))
          .map((it) => ({ ...it, selected: true }))
      );
    }
  }, [adminLocation]);

  const stepschecked =
    steps && steps?.filter((it) => it.selected)?.map((it) => it.location_id);

  const getStepData =
    adminLocation &&
    adminLocation?.payload?.data.filter((val) =>
      stepsArr.includes(val.location_id)
    );

  const [stepsChecked, setStepChecked] = useState([]);

  let result =
    monthWiseAvailability &&
    monthWiseAvailability?.payload?.data?.reduce(function (r, a) {
      r[a.sku] = r[a.sku] || [];
      r[a.sku].push(a);
      return r;
    }, Object.create(null));

  // const wiseStockReport = result && Object.values(result);
  const wiseStockReport = monthWiseAvailability?.payload?.data || [];

  const { Option } = Select;

  const onChangeDate = (date, dateString) => {
    setpendingDate(dateString);
  };

  const onChangeCheckBox = (e) => {
    setBGradeChecked(e.target.checked);
  };

  const handlePendingOrder = (e) => {
    setPendingChecked(e.target.checked);
  };

  const sesionSelectAll = (e) => {
    setAllSesion(e.target.checked);
  };

  const isCheckboxChecked = (id, value) => {
    const filterCheckBox =
      getNewSeasonReducer &&
      getNewSeasonReducer?.payload?.data.find((val) => val.season_id === id);
    const checkId = isChecked.includes(id);
    if (!checkId) {
      setIsChecked((current) => [...current, filterCheckBox.season_id]);
    }

    if (!value) {
      const removeUnCheck = isChecked.filter(
        (item) => item !== filterCheckBox.season_id
      );
      setIsChecked(removeUnCheck);
    }
    setAllSesion(false);
  };

  function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }

  let query = useQuery();
  let salePersonId = query.get("salesperson_id");
  let regionId = query.get("region_id");
  let genderId = query.get("gender_id");
  let customerTypeID = query.get("customer_type_id");
  let cyStartDate = query.get("cy_start_date");
  let cyEndDate = query.get("cy_end_date");


    useEffect(() => {
      if (cyStartDate) {
        const params = {
          season_id: null,
          style_id: null,
          region_id: (regionId === "All" || regionId === "null") ? null : regionId.toString(),
          gender_id: (genderId === "All" || genderId === "null") ? null : genderId,
          customer_id: null,
          sales_person_id: (salePersonId === "All" || salePersonId === "null") ? null : salePersonId,
          from_date: moment(cyStartDate).format("YYYY-MM-DD"),
          to_date: moment(cyEndDate).format("YYYY-MM-DD"),
          sku: null,
          order_header_no: null,
          customer_type_id: (customerTypeID === "All" || customerTypeID === "null") ? null : customerTypeID,
        };
        form.setFieldsValue({
          sp: salePersonId === "null" ? null : salePersonId,
          region: regionId === "null" ? null : regionId,
          gender: genderId === "null" ? null : genderId,
          cutomer_category: customerTypeID === "null" ? null : customerTypeID,
          fromDate: moment(cyStartDate),
          toDate: moment(cyEndDate),
        });
        setLoading(true)
        dispatch(getMonthWiseAvailability(token, params)).then((res) => {
          setLoading(false)
        });
      }
    }, [cyStartDate])



  const onFinish = async (e) => {
    setLoading(true);
    await form.validateFields().then((values) => {
      const hasOrderNo =
        values.order_header_no && values.order_header_no.trim() !== "";
      if (hasOrderNo) {
        const orderNo = values.order_header_no;
        form.resetFields(); // baaki sab default ho jayenge
        form.setFieldsValue({
          order_header_no: orderNo, // sirf order no wapas set
        });
        // Reset ke baad fresh values le lo
        values = form.getFieldsValue();
      }
      values.BGradeStock = BGradechecked;
      values.stepsChecked = stepsChecked;
      values.isChecked = isChecked;
      if (allSesion) {
        values.allSesion = allSesion;
      }

      if (pendingChecked) {
        stepschecked.push(-1);
      }
      const params = {
        season_id: null,
        style_id: values.style === "All" ? null : values.style,
        region_id: (values.region === "All" || values.region == null) ? null : values.region,
        gender_id: (values.gender === "All" || values.gender == null) ? null : values.gender,
        customer_id: values.customer === "All" ? null : values.customer,
        sales_person_id: values.sp === "All" ? null : values.sp,
        from_date:
          uploaded || values.order_header_no
            ? "2020-01-01"
            : moment(values.fromDate).format("YYYY-MM-DD"),
        to_date:
          uploaded || values.order_header_no
            ? "2099-12-31"
            : moment(values.toDate).format("YYYY-MM-DD"),
        sku: values.sku ? values.sku : null,
        order_header_no: values.order_header_no ? values.order_header_no : null,
        customer_type_id:
          values.cutomer_category === "All" ? null : values.cutomer_category,
        pending_orders: uploaded
          ? pendingOrders.map((item) => item.order_no)
          : null,
      };
      setDummyData(params);
      if (isSort) {
        downloadCombinedExcel(params).finally(() => setLoading(false));
        return;
      }
      dispatch(getMonthWiseAvailability(token, params))
        .then((res) => {
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    });
  };
  const maxAllocationColumns = Math.max(
    0,
    ...wiseStockReport.map(
      (row) =>
        row.fullfilled_data?.allocation_data?.flatMap((g) => g.values?.map((v) => v.key) || [])
          .length || 0
    )
  );

  let sumQuantity;
  let currentOrder = null;
  let rowIndex = 0;
  const columns =
    pendingOrders?.length > 0
      ? Object.keys(pendingOrders[0]).map((key) => ({
        title: key,
        dataIndex: key,
        key: key,
      }))
      : [];

  useEffect(() => {
    dispatch(getStyle(token, menuId));
    dispatch(loadSalePerson(token));
    dispatch(getProductType(token, menuId));
    dispatch(getGenderCategory(token, menuId));
    dispatch(getNewSeason(token, menuId));
    dispatch(getProductStatus(token, menuId));
    dispatch(getAdminLocation(token, menuId));
    dispatch(getRegion(token, menuId));
    dispatch(getGender(token, menuId));
    dispatch(getSeason(token, menuId));
    dispatch(getCustomerType(token));
  }, [dispatch, menuId, token]);

  useEffect(() => {
    if (allSesion) {
      setIsChecked([]);
    }
  }, [allSesion]);

  function debounce(cb, delay = 1000) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        cb(...args);
      }, delay);
    };
  }

  const handleChanges = (val) => {
    dispatch(getSaleOrderFormData(token, company_id, menuId, val, ""));
  };

  const optimizedFn = useCallback(debounce(handleChanges), []);

  let netQty =
    monthWiseAvailability &&
    monthWiseAvailability?.payload?.data?.reduce(function (
      previousValue,
      currentValue
    ) {
      let val = parseFloat(currentValue?.totalqty);
      if (isNaN(val)) val = 0;
      return previousValue + val;
    },
      0);

  let netAmount =
    monthWiseAvailability &&
    monthWiseAvailability?.payload?.data?.reduce(function (
      previousValue,
      currentValue
    ) {
      let val = parseFloat(currentValue?.amount);
      if (isNaN(val)) val = 0;
      return previousValue + val;
    },
      0);

  const handleUpload = (file) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      const data = e.target.result;

      const workbook = XLSX.read(data, { type: "binary" });

      const sheetName = workbook.SheetNames[0];

      const sheet = workbook.Sheets[sheetName];

      const parsedData = XLSX.utils.sheet_to_json(sheet);

      console.log(parsedData); // yahan data mil jayega
      setPendingOrders(parsedData);
    };
    setFormDisabled(true);
    handleReset();
    setUploaded(true);
    reader.readAsBinaryString(file);

    return false; // upload stop
  };
  const removeFile = () => {
    setFormDisabled(false);
    setUploaded(false);
    setPendingOrders([]);
  };
  const handleReset = () => {
    form.resetFields();

    setUploaded(false);
    setPendingOrders([]);
    setIsModalOpen(false);

    // agar ye states bhi reset karni hain
    setIsChecked([]);
  };

  const downloadPendingAvailabilityExcel = async () => {
    const response = await axios.post(
      `${BASEURL}getAll/DownloadPendingReportWithAvailability`,
      dummyData,
      {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.setAttribute("download", "Month Wise Availability.xlsx");

    document.body.appendChild(link);
    link.click();
    link.remove();

    window.URL.revokeObjectURL(url);
  };
  const PENDING_REPORT_URL = `${BASEURL}getAll/getStyleWisePendingReportWithAvailability`; // action wala URL

  const downloadCombinedExcel = async (params) => {
    try {
      const response = await axios.post(
        PENDING_REPORT_URL,
        { ...params, is_sort: true },
        {
          responseType: "blob",
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      // Agar backend ne error JSON bheja ho (blob ki shakal mein)
      if (response.data?.type?.includes("application/json")) {
        const text = await response.data.text();
        const json = JSON.parse(text);
        message.error(json?.message || json?.data || "Failed to generate Excel");
        return;
      }

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Month Wise Availability - Combined.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      // Error ka body bhi blob hota hai, usay parse karke message dikhayein
      let msg = "Failed to generate Excel";
      try {
        const text = await err?.response?.data?.text();
        const json = JSON.parse(text);
        msg = json?.message || json?.data || msg;
      } catch (e) { }
      message.error(msg);
    }
  };

  const handleSchedule = () => {
    form
      .validateFields()
      .then((values) => {
        const report_filters = {
          season_id: null,
          pending_orders: null,
          customer_id:
            values.customer === "All" || values.customer === undefined
              ? null
              : values.customer,
          region_id:
            values.region === "All" || values.region === undefined
              ? null
              : values.region.toString(),
          sales_person_id:
            values.sp === "All" || values.sp === undefined
              ? null
              : values.sp.toString(),
          customer_type_id:
            values.cutomer_category === undefined ||
              values.cutomer_category === "All"
              ? null
              : values.cutomer_category,
          gender_id:
            values.gender === undefined || values.gender === "All"
              ? null
              : values.gender,
          style_id:
            values.style === undefined || values.style === "All"
              ? null
              : values.style,
          from_date: moment.utc(values?.fromDate).format("MM-DD-YYYY"),
          to_date: moment.utc(values?.toDate).format("MM-DD-YYYY"),
          sku: values.sku ? values.sku : null,
          order_header_no: values.order_header_no
            ? values.order_header_no
            : null,
        };

        const getNameFromList = (
          list,
          id,
          idKey,
          nameKey,
          defaultValue = "All"
        ) => {
          if (!id || id === "All") return defaultValue;

          const item = list?.find((it) => it[idKey] === id);
          return item ? item[nameKey] : defaultValue;
        };

        // Labels for UI
        const uiData = {
          Customer: getNameFromList(
            saleOrderFormData?.payload?.customerDetail,
            values.customer,
            "customer_id",
            "customer_name"
          ),
          Region: getNameFromList(
            region?.payload?.data,
            values.region,
            "region_id",
            "region_name"
          ),
          "Sales Person": getNameFromList(
            salePerson?.payload?.data,
            values.sp,
            "sales_person_id",
            "salesperson_name"
          ),
          "Cus Type": getNameFromList(
            customerTypes?.payload?.data,
            values.cutomer_category,
            "customer_type_id",
            "customer_type_name"
          ),
          Gender: getNameFromList(
            gender?.payload?.data,
            values.gender,
            "gender_id",
            "gender_name"
          ),
          Style: getNameFromList(
            style?.payload?.data,
            values.style,
            "style_id",
            "style_name"
          ),
          "From Date": moment(values.fromDate).format("MM-DD-YYYY"),
          "To Date": moment(values.toDate).format("MM-DD-YYYY"),
          SKU: values.sku || "All",
          "Order #": values.order_header_no || "All",
          // "Customer Type": getNameFromList(customerTypeNew?.payload?.data, values.Customer_type, "customer_type_id", "customer_type_name"),
        };
        const emailDates = {
          from: `01-01-${values.current_year}`,
          to: `12-31-${values.current_year}`,
        };
        const report_columns = {
          // bussinessdashboard
        };
        setScheduleData({
          uiData,
          report_filters,
          report_columns,
          report_id: 4,
          report_name: "Month Wise Availability",
          api_route: "/DownloadPendingReportWithAvailability",
          type: "pdf",
          emailDates,
        });

        setIsModalOpen1(true);
      })
      .catch((errorInfo) => {
        console.log("Form validation failed:", errorInfo);
      });
  };

  return (
    <>
      <ScheduleModal
        token={token}
        open={isModalOpen1}
        data={scheduleData || {}}
        onClose={() => setIsModalOpen1(false)}
      />
      <div className=" header_class business_header_oms">
        <div className="row justify-content-between business_class_oms distributor">
          <div className="col-3 d-flex align-items-start box-space">
            <div className="logobrand">
              <img id="ImgLogo" alt="logo" src={logo} />
            </div>
          </div>
          {/* <div className="col-sm-6 box-space pl-sm-0">
                    <div className="brand-para">
                        <div>DL1961 Premium Denim Inc.</div>
                        <div>121 Varick Street</div>
                        <div>4th Floor</div>
                        <div>New York, NY 10013</div>
                        <div>(P) 646-514-9736</div>
                        <div>(F) 212-991-9989</div>
                        <div>(E) sales@DL1961.com</div>
                    </div>
                </div> */}
          <div className="col-4 box-space right-content-header text-right">
            <div className=" d-flex justify-content-end">
              <div className=" d-flex justify-content-end mr-8">
                {/* <div className="print_icon printing_class">
                <i
                  id="Image1"
                  title="Print"
                  alt="Print"
                  src={btnPrint}
                  className="fa-solid fa-print"
                ></i>
              </div> */}
                <div
                  className="print_icon printing_class"
                  name="ImgExcel"
                  alt="Export to excel"
                  id="ImgExcel"
                  title="Export to excel"
                  src={xlsx}
                >
                  <input
                    type="image"
                    name="ImgExcel"
                    alt="Export to excel"
                    id="ImgExcel"
                    title="Export to excel"
                    src={xlsx}
                    onClick={downloadPendingAvailabilityExcel}
                    style={{
                      borderWidth: "0px",
                      height: "14px",
                      cursor: "pointer",
                    }}
                  />
                </div>
                <div
                  className="print_icon printing_class"
                  name="ImgExcel"
                  alt="Export to excel"
                  id="ImgExcel"
                  title="Export to excel"
                  src={xlsx}
                >
                  {wiseStockReport ? (
                    <>
                      <input
                        type="image"
                        name="ImgExcel"
                        alt="Export to excel"
                        id="ImgExcel"
                        title="Export to excel"
                        src={xlsx}
                        onClick={onDownload}
                        style={{
                          borderWidth: "0px",
                          height: "14px",
                          cursor: "pointer",
                        }}
                      />
                    </>
                  ) : (
                    <input
                      type="image"
                      name="ImgExcel"
                      alt="Export to excel"
                      id="ImgExcel"
                      title="Export to excel"
                      src={xlsx}
                      style={{ borderWidth: "0px", height: "14px" }}
                    />
                  )}
                </div>
              </div>
              <span style={{ fontSize: "small", fontWeight: "bolder" }}>
                Month Wise Availability
                <br />
                Rpt # 489
                <br />
                Login as:{" "}
                <span id="lblSalesPerson" style={{ fontWeight: "bold" }}>
                  {userName}
                </span>
              </span>
            </div>
          </div>
        </div>

        {/*  */}
        <div className="business_class_oms distributor">
          {/* Table Selects */}
          <Form form={form} name="control-hooks" onFinish={onFinish}>
            <div className="main_form row">
              <div className=" col-12">
                {/* <hr className="mt-0 mb-2" />
              <div>
                <label>Season</label>
                <div className="checkboxes">
                  <div className="checkbox_content">
                    <Checkbox
                      size="small"
                      checked={allSesion}
                      onChange={sesionSelectAll}
                    >
                      All
                    </Checkbox>
                  </div>
                  {getNewSeasonReducer &&
                    getNewSeasonReducer?.payload?.data.map((session, index) => {
                      return (
                        <div key={index} className="checkbox_content">
                          <Checkbox
                            size="small"
                            checked={allSesion ? false : isChecked.includes(session.season_id)}
                            
                            
                            onChange={(e) =>
                              isCheckboxChecked(
                                session.season_id,
                                e.target.checked
                              )
                            }
                          
                          
                          
                          
                          
                          
                          
                          
                          >
                            {session.season_name}
                          </Checkbox>
                        </div>
                      );
                    })}
                </div>
              </div> */}
                <hr className="my-1" />

                <div className="row">
                  <div className="col-12 col-md-3">
                    <div className=" d-flex flex-row align-items-baseline">
                      <label className="labels width44">Customer</label>
                      <div className=" w-100 fit-selectbox-width">
                        <Form.Item name="customer" initialValue={"All"}>
                          <Select
                            disabled={formDisabled}
                            notFoundContent={
                              saleOrderFormData.loading ? (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <Loader
                                    type="Oval"
                                    color="#3c4b58"
                                    height={20}
                                    width={20}
                                  />
                                </div>
                              ) : (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    textAlign: "center",
                                  }}
                                >
                                  No Data
                                </div>
                              )
                            }
                            className={"select_Inputs"}
                            autoComplete={"nope"}
                            size="small"
                            showSearch
                            optionFilterProp="children"
                            loading={saleOrderFormData.loading}
                            defaultValue={form.getFieldValue().customer}
                            onSearch={(value) => {
                              optimizedFn(value);
                            }}
                          >
                            <Option value={null}>All</Option>
                            {saleOrderFormData?.payload?.customerDetail.map(
                              (item) => {
                                return (
                                  <Option
                                    defaultValue={"All"}
                                    key={item.customer_id}
                                  >
                                    {`${item.customer_name}`}
                                  </Option>
                                );
                              }
                            )}
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  {/* Second */}
                  <div className="col-12 col-md-3">
                    <div className=" d-flex flex-row align-items-baseline">
                      <label className="labels width44">Region</label>
                      <div className=" w-100 fit-selectbox-width">
                        <Form.Item initialValue={"All"} name="region">
                          <Select
                            disabled={formDisabled}
                            className={"select_Inputs"}
                            showSearch
                            optionFilterProp="children"
                            size="small"
                            filterOption={(input, option) =>
                              option.children
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                          >
                            <Option value={null}>All</Option>
                            {region &&
                              region?.payload?.data.map((res, index) => {
                                return (
                                  <Option
                                    defaultValue={"All"}
                                    key={res.region_id}
                                    value={res.region_id}
                                  >
                                    {res.region_name}
                                  </Option>
                                );
                              })}
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  {/* Third */}
                  <div className="col-12 col-md-3">
                    <div className=" d-flex flex-row align-items-baseline">
                      <label className="labels width44">Sales Person</label>
                      <div className=" w-100 fit-selectbox-width">
                        <Form.Item initialValue={"All"} name="sp">
                          <Select
                            disabled={formDisabled}
                            className={"select_Inputs"}
                            showSearch
                            optionFilterProp="children"
                            size="small"
                            filterOption={(input, option) =>
                              option.children
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                          >
                            <Option value={null}>All</Option>
                            {salePerson &&
                              salePerson?.payload?.data.map((style, index) => {
                                return (
                                  <Option
                                    defaultValue={"All"}
                                    key={style.sales_person_id}
                                  >
                                    {style.salesperson_name}
                                  </Option>
                                );
                              })}
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  {/* Fourth */}
                  <div className="col-12 col-md-3">
                    <div className=" d-flex flex-row align-items-baseline">
                      <label className="labels width44">Cus Type</label>
                      <div className="w-100 fit-selectbox-width">
                        <Form.Item initialValue={"All"} name="cutomer_category">
                          <Select
                            disabled={formDisabled}
                            className={"select_Inputs"}
                            showSearch
                            placeholder="Select Gender"
                            optionFilterProp="children"
                            size="small"
                            filterOption={(input, option) =>
                              option.children
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                          >
                            <Option value={null}>All</Option>
                            {customerTypes?.payload?.data.map((val) => {
                              return (
                                <Option key={val.customer_type_id}>
                                  {val.customer_type_name}
                                </Option>
                              );
                            })}
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-md-3">
                    <div className=" d-flex flex-row align-items-baseline">
                      <label className="labels width44">Gender</label>
                      <div className=" w-100 fit-selectbox-width">
                        <Form.Item initialValue={"All"} name="gender">
                          <Select
                            disabled={formDisabled}
                            className={"select_Inputs"}
                            showSearch
                            optionFilterProp="children"
                            size="small"
                            filterOption={(input, option) =>
                              option.children
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                          >
                            <Option value={null}>All</Option>
                            {gender &&
                              gender?.payload?.data.map((res) => {
                                return (
                                  <Option
                                    defaultValue={"All"}
                                    key={res.gender_id}
                                  >
                                    {res.gender_name}
                                  </Option>
                                );
                              })}
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  {/* Second */}
                  <div className="col-12 col-md-3">
                    <div className=" d-flex flex-row align-items-baseline">
                      <label className="labels width44">Style</label>
                      <div className=" w-100 fit-selectbox-width">
                        <Form.Item initialValue={"All"} name="style">
                          <Select
                            disabled={formDisabled}
                            className={"select_Inputs"}
                            showSearch
                            optionFilterProp="children"
                            size="small"
                            filterOption={(input, option) =>
                              option.children
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                          >
                            <Option value={null}>All</Option>
                            {style &&
                              style?.payload?.data.map((res) => {
                                return (
                                  <Option
                                    defaultValue={"All"}
                                    key={res.style_id}
                                    value={res.style_id}
                                  >
                                    {res.style_name}
                                  </Option>
                                );
                              })}
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  {/* Third */}
                  <div className="col-12 col-md-3">
                    <div className=" d-flex flex-row align-items-baseline">
                      <label className="labels width44">From Date</label>
                      <div className="full_date">
                        <Form.Item
                          name="fromDate"
                          initialValue={moment().subtract(1, "years")}
                        >
                          <DatePicker
                            disabled={true}
                            size="small"
                            defaultValue={moment().format("MM-DD-YYYY")}
                            format={dateFormat}
                          />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  {/* Fourth */}
                  <div className="col-12 col-md-3">
                    <div className=" d-flex flex-row align-items-baseline">
                      <label className="labels width44">To Date</label>
                      <div className="full_date">
                        <Form.Item
                          name="toDate"
                          initialValue={moment().add(2, 'year').endOf('Years')}
                        >
                          <DatePicker
                            disabled={true}
                            size="small"
                            defaultValue={moment().format("MM-DD-YYYY")}
                            format={dateFormat}
                          />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-md-3">
                    <div className=" d-flex flex-row align-items-baseline mt-1">
                      <label className="labels width44">SKU</label>
                      <div className="full_date">
                        <Form.Item name="sku" className="sku_input">
                          <Input
                            size="small"
                            className={"select_Inputs"}
                            disabled={formDisabled}
                          />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3">
                    <div className=" d-flex flex-row align-items-baseline mt-1">
                      <label className="labels width44">Order #</label>
                      <div className="full_date">
                        <Form.Item name="order_header_no" className="sku_input">
                          <Input
                            size="small"
                            className={"select_Inputs"}
                            disabled={
                              formDisabled &&
                              !form.getFieldValue("order_header_no")
                            }
                            onChange={(e) => {
                              const value = e.target.value;

                              if (value && value.trim() !== "") {
                                setFormDisabled(true);
                              } else {
                                setFormDisabled(false);
                              }
                            }}
                          />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-2">
                    <div
                      className="d-flex flex-row align-items-center mt-1"
                      style={{ height: "24px" }}
                    >
                      <Checkbox
                        checked={isSort}
                        onChange={(e) => setIsSort(e.target.checked)}
                        style={{ fontSize: "12px", whiteSpace: "nowrap", margin: 0 }}
                      >
                        Combined Excel
                      </Checkbox>
                    </div>
                  </div>
                  <div className="col-12 col-md-3">
                    <div className="d-flex flex-row align-items-center mt-1"
                      style={{ height: "24px", fontSize: "12px" }}>
                      <>
                        {(() => {
                          const job = monthWiseAvailability?.payload?.status?.job;

                          if (job?.startedAt) {
                            return `Started at: ${moment(job.startedAt).format(
                              "MM-DD-YYYY hh:mm:ss A"
                            )} PKT`;
                          }

                          return null;
                        })()}

                        {(() => {
                          const job = monthWiseAvailability?.payload?.status?.job;

                          if (job?.finishedAt) {
                            return (
                              <>
                                <br />
                                Completed at: {moment(job.finishedAt).format(
                                  "MM-DD-YYYY hh:mm:ss A"
                                )} PKT
                              </>
                            );
                          }

                          return null;
                        })()}
                      </>

                    </div>
                  </div>
                  <div className="col-12 col-md-5">
                    <div className=" d-flex flex-row align-items-baseline mt-1">
                      {" "}
                      <a href="/sample-pending-order-list.xlsx" download>
                        <Button
                          loading={loading}
                          type="primary"
                          icon={<DownloadOutlined />}
                          className="submit-btn-btm m-0 px-2"
                        >
                          Bulk Order Template
                        </Button>
                      </a>
                      <Upload
                        beforeUpload={handleUpload}
                        showUploadList={false}
                        accept=".xlsx,.xls"
                        maxCount={1}
                      >
                        <Button
                          loading={loading}
                          type="primary"
                          icon={<UploadOutlined />}
                          disabled={form.getFieldValue("order_header_no")}
                          className="submit-btn-btm m-0 mx-2"
                        >
                          Bulk Order Upload
                        </Button>
                      </Upload>
                      {uploaded && (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                          }}
                        >
                          <span
                            onClick={() => setIsModalOpen(true)}
                            style={{
                              fontSize: "12px",
                              cursor: "pointer",
                              color: "green",
                              marginRight: "10px",
                            }}
                          >
                            Uploaded!
                          </span>

                          <CloseCircleOutlined
                            onClick={removeFile}
                            style={{
                              color: "red",
                              cursor: "pointer",
                              fontSize: "14px",
                            }}
                          />
                        </div>
                      )}
                      {/* <label className="labels width44">Cus Type</label>
                    <div className="w-100 fit-selectbox-width">
                      <Form.Item initialValue={"All"} name="cutomer_category">
                        <Select
                          className={"select_Inputs"}
                          showSearch
                          placeholder="Select Gender"
                          optionFilterProp="children"
                          size="small"
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                        >
                          <Option value="All">All</Option>
                          {customerTypes?.payload?.data.map((val) => {
                            return (
                              <Option value={val.customer_type_id}>
                                {val.customer_type_name}
                              </Option>
                            );
                          })}
                        </Select>
                      </Form.Item>
                    </div> */}
                    </div>
                  </div>
                  <div className="col-1">
                    {/* <div
                      className=" d-flex flex-row align-items-baseline"
                      style={{
                        justifyContent: "start",
                        marginTop: "3px",
                      }}
                    >
                      {userRights && (
                        <Button type="primary" onClick={handleSchedule}>
                          Schedule
                        </Button>
                      )}
                    </div> */}
                  </div>
                  <div className="col-12 col-md-6">
                    <div className=" d-flex flex-row align-items-baseline">
                      <div className=" w-100">
                        <div style={{ display: "flex" }}>
                          <div
                            className=" w-100 d-flex align-items-center justify-content-end"
                            style={{ gap: "10px" }}
                          >
                            {/* {monthWiseAvailability?.payload?.data && (
                            <span
                              className="ml-10"
                              style={{
                                fontSize: "12px",
                              }}
                            >
                              {monthWiseAvailability?.payload?.data
                                ?.length > 0
                                ? `Total Qty:   ${numeral(netQty).format(
                                    "0,0"
                                  )}`
                                : ""}
                              &nbsp; &nbsp; &nbsp;
                              {monthWiseAvailability?.payload?.data
                                ?.length > 0
                                ? `Total Amount:   ${numeral(netAmount).format(
                                    "$0,0.00"
                                  )}`
                                : ""}
                            </span>
                          )} */}

                            <Button
                              loading={loading}
                              type="primary"
                              htmlType="submit"
                              className="submit-btn-btm mt-1 mx-0"
                            >
                              Generate
                            </Button>
                            {/* <Button
                            onClick={handleReset}
                            loading={loading}
                            type="primary"
                            className="submit-btn-btm m-1"
                            style={{ marginLeft: "auto" }}
                          >
                            Reset
                          </Button> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </Form>
        </div>
        <div className="overflow" ref={tableRef}>
          {!loading ? (
            wiseStockReport.length > 0 ? (
              wiseStockReport.map((data, index) => {
                const sizes = data;
                // ORDER WISE INDEXING
                if (currentOrder !== data.order_header_no) {
                  currentOrder = data.order_header_no;
                  rowIndex = 1;
                } else {
                  rowIndex++;
                }

                // CHECK ORDER END
                const isLastRowOfOrder =
                  wiseStockReport[index + 1]?.order_header_no !==
                  data.order_header_no;
                // const currentOrderRows = wiseStockReport.filter(
                //   (item) => item.order_header_no === data.order_header_no
                // );

                // const maxAllocationColumns = Math.max(
                //   ...currentOrderRows.map(
                //     (row) =>
                //       row.allocation_data?.flatMap(
                //         (g) => g.values?.map((v) => v.key) || []
                //       ).length || 0
                //   )
                // );

                let qty1 = parseInt(data.qty_1 || 0);
                let qty2 = parseInt(data.qty_2 || 0);
                let qty3 = parseInt(data.qty_3 || 0);
                let qty4 = parseInt(data.qty_4 || 0);
                let qty5 = parseInt(data.qty_5 || 0);
                let qty6 = parseInt(data.qty_6 || 0);
                let qty7 = parseInt(data.qty_7 || 0);
                let qty8 = parseInt(data.qty_8 || 0);
                let qty9 = parseInt(data.qty_9 || 0);
                let qty10 = parseInt(data.qty_10 || 0);
                let qty11 = parseInt(data.qty_11 || 0);
                let qty12 = parseInt(data.qty_12 || 0);
                let qty13 = parseInt(data.qty_13 || 0);
                let qty14 = parseInt(data.qty_14 || 0);
                let qty15 = parseInt(data.qty_15 || 0);
                let qty16 = parseInt(data.qty_16 || 0);

                let totalQuantity = parseInt(data.totalqty || 0);
                let discount = parseFloat(data.disc_amount || 0);
                let tax = parseFloat(data.tax_amount || 0);
                let amount = parseFloat(data.amount || 0);

                // dynamic allocation headers
                const allocationHeaders =
                  data.fullfilled_data?.allocation_data?.map((item) => item.key) || [];

                const allocationGroups = data.fullfilled_data?.allocation_data || [];

                // group headers (big columns)
                // const allocationGroupHeaders = allocationGroups.map((g) => ({
                //   key: g.key,
                //   span: g.values?.length || 1,
                // }));
                const allocationGroupHeaders = allocationGroups.map((g) => {
                  const childWithoutTotal =
                    g.values?.filter((v) => v.key !== "Total") || [];

                  return {
                    key: g.key,
                    span: childWithoutTotal.length || 1,
                  };
                });

                // flat child headers (actual columns)
                // const allocationChildHeaders = allocationGroups.flatMap(
                //   (g) => g.values?.map((v) => v.key) || []
                // );
                const allocationChildHeaders = allocationGroups.flatMap(
                  (g) =>
                    g.values
                      ?.filter((v) => v.key !== "Total")
                      .map((v) => v.key) || []
                );

                const allocationValues =
                  data.fullfilled_data?.allocation_data?.flatMap(
                    (g) => g.values?.map((v) => v.value) || []
                  ) || [];

                return (
                  <div
                    className="fitWidth"
                    style={{ margin: "0 auto" }}
                    key={index}
                  >
                    <div className="table_data-Heading"></div>

                    <table
                      className="table_distributor-data table-auto-adjust"
                      style={{ maxWidth: "1400px" }}
                    >
                      <tbody>
                        {/* HEADER */}
                        <tr className="font_weight">
                          <td
                            rowSpan={2}
                            style={{
                              width: "20px",
                              border: "1px solid rgb(187, 187, 187);",
                            }}
                          >
                            #
                          </td>

                          <td rowSpan={2} style={{ width: "50px" }}>
                            SKU
                          </td>

                          <td rowSpan={2} style={{ width: "40px" }}>
                            Inseam
                          </td>

                          <td rowSpan={2} style={{ width: "90px" }}>
                            Style
                          </td>

                          <td rowSpan={2} style={{ width: "60px" }}>
                            Wash
                          </td>
                          <td rowSpan={2} style={{ width: "60px" }}>
                            Gender
                          </td>
                          <td rowSpan={2} style={{ width: "60px" }}>
                            Season
                          </td>

                          <td rowSpan={2} style={{ width: "55px" }}>
                            Order #
                          </td>

                          <td rowSpan={2} style={{ width: "80px" }}>
                            PO #
                          </td>

                          <td rowSpan={2} style={{ width: "60px" }}>
                            Order Date
                          </td>

                          <td rowSpan={2} style={{ width: "60px" }}>
                            Start Date
                          </td>

                          <td rowSpan={2} style={{ width: "60px" }}>
                            End Date
                          </td>

                          <td rowSpan={2} style={{ width: "100px" }}>
                            Customer
                          </td>

                          <td rowSpan={2} style={{ width: "100px" }}>
                            Customer Type
                          </td>

                          <td rowSpan={2} style={{ width: "30px" }}>
                            State
                          </td>

                          <td rowSpan={2} style={{ width: "70px" }}>
                            Region
                          </td>

                          <td rowSpan={2} style={{ width: "80px" }}>
                            Sales Person
                          </td>

                          <td
                            rowSpan={2}
                            style={{
                              width: "20px",
                              textAlign: "right",
                              paddingRight: "2px",
                            }}
                          >
                            Qty
                          </td>

                          <td
                            rowSpan={2}
                            style={{
                              width: "50px",
                              textAlign: "right",
                              paddingRight: "2px",
                            }}
                          >
                            Rate
                          </td>

                          <td
                            rowSpan={2}
                            style={{
                              width: "40px",
                              textAlign: "right",
                              paddingRight: "2px",
                            }}
                          >
                            Discount
                          </td>

                          <td
                            rowSpan={2}
                            style={{
                              width: "40px",
                              textAlign: "right",
                              paddingRight: "2px",
                            }}
                          >
                            Amount
                          </td>

                          <td
                            rowSpan={2}
                            style={{
                              width: "40px",
                              textAlign: "right",
                              paddingRight: "2px",
                            }}
                          >
                            Tax
                          </td>

                          <td rowSpan={2} style={{ width: "30px" }}>
                            Term
                          </td>

                          <td rowSpan={2} style={{ width: "100px" }}>
                            CIT Status
                          </td>
                          <td rowSpan={2} style={{ width: "100px" }}>
                            Extension Needed
                          </td>
                          <td rowSpan={2} style={{ width: "100px" }}>
                            Last Fulfillment Location
                          </td>

                          <td colSpan={16} style={{ textAlign: "center" }}>
                            Pending Units
                          </td>
                          <td rowSpan={2}>Total</td>
                          {/* DYNAMIC ALLOCATION HEADERS */}
                          {/* GROUP HEADERS */}
                          {allocationGroupHeaders.map((g, i) => (
                            <>
                              <td
                                key={i}
                                colSpan={g.span}
                                style={{ textAlign: "center" }}
                              >
                                {g.key}
                              </td>
                              <td rowSpan={2} style={{ textAlign: "center" }}>
                                Total
                              </td>
                              <td rowSpan={2}></td>
                            </>
                          ))}
                        </tr>
                        <tr className="font_weight">
                          {/* SIZE HEADERS */}
                          <td style={{ textAlign: "right" }}>{sizes.size_1}</td>
                          <td style={{ textAlign: "right" }}>{sizes.size_2}</td>
                          <td style={{ textAlign: "right" }}>{sizes.size_3}</td>
                          <td style={{ textAlign: "right" }}>{sizes.size_4}</td>
                          <td style={{ textAlign: "right" }}>{sizes.size_5}</td>
                          <td style={{ textAlign: "right" }}>{sizes.size_6}</td>
                          <td style={{ textAlign: "right" }}>{sizes.size_7}</td>
                          <td style={{ textAlign: "right" }}>{sizes.size_8}</td>
                          <td style={{ textAlign: "right" }}>{sizes.size_9}</td>
                          <td style={{ textAlign: "right" }}>
                            {sizes.size_10}
                          </td>
                          <td style={{ textAlign: "right" }}>
                            {sizes.size_11}
                          </td>
                          <td style={{ textAlign: "right" }}>
                            {sizes.size_12}
                          </td>
                          <td style={{ textAlign: "right" }}>
                            {sizes.size_13}
                          </td>
                          <td style={{ textAlign: "right" }}>
                            {sizes.size_14}
                          </td>
                          <td style={{ textAlign: "right" }}>
                            {sizes.size_15}
                          </td>
                          <td style={{ textAlign: "right" }}>
                            {sizes.size_16}
                          </td>
                          {/* size headers */}
                          {allocationChildHeaders.map((key, i) => (
                            <td
                              key={i}
                              style={{ textAlign: "right" }}
                            // className={`${
                            //   allocationValues[i] > 0 || allocationValues[i] < 0
                            //     ? "bold-title"
                            //     : ""
                            // }`}
                            >
                              {key}
                            </td>
                          ))}
                        </tr>

                        {/* BODY */}
                        <tr>
                          {/* <td>{index + 1}</td> */}
                          <td>{rowIndex}</td>

                          <td>{data.sku}</td>

                          <td>{data.inseam}</td>

                          <td>{data.style_name}</td>

                          <td>{data.wash_name}</td>
                          <td>{data.gender_name}</td>
                          <td>{data.new_season}</td>

                          <td>{data.order_header_no}</td>

                          <td>{data.reference_no}</td>

                          <td>{data.order_date}</td>

                          <td>{data.start_date}</td>

                          <td>{data.end_date}</td>

                          <td>{data.first_name}</td>

                          <td>{data.customer_type_name}</td>

                          <td>{data.state_name}</td>

                          <td>{data.region_name}</td>

                          <td>
                            {data.salesperson_name === null
                              ? "N/A"
                              : data.salesperson_name}
                          </td>

                          <td
                            style={{ textAlign: "right", paddingRight: "2px" }}
                          >
                            {data.totalqty}
                          </td>

                          <td
                            style={{ textAlign: "right", paddingRight: "2px" }}
                          >
                            $ {parseFloat(data.rate).toFixed(2)}
                          </td>

                          <td
                            style={{ textAlign: "right", paddingRight: "2px" }}
                          >
                            $ {parseFloat(data.disc_amount).toFixed(2)}
                          </td>

                          <td
                            style={{ textAlign: "right", paddingRight: "2px" }}
                          >
                            $ {parseFloat(data.amount).toFixed(2)}
                          </td>

                          <td
                            style={{ textAlign: "right", paddingRight: "2px" }}
                          >
                            $ {parseFloat(data.tax_amount).toFixed(2)}
                          </td>

                          <td>{data.term}</td>

                          <td>{data.factor_decision}</td>
                          <td>{data.fullfilled_data?.extended}</td>
                          <td>{data.fullfilled_data?.fulfill_type}</td>

                          <td style={{ textAlign: "right" }}>{data.qty_1}</td>
                          <td style={{ textAlign: "right" }}>{data.qty_2}</td>
                          <td style={{ textAlign: "right" }}>{data.qty_3}</td>
                          <td style={{ textAlign: "right" }}>{data.qty_4}</td>
                          <td style={{ textAlign: "right" }}>{data.qty_5}</td>
                          <td style={{ textAlign: "right" }}>{data.qty_6}</td>
                          <td style={{ textAlign: "right" }}>{data.qty_7}</td>
                          <td style={{ textAlign: "right" }}>{data.qty_8}</td>
                          <td style={{ textAlign: "right" }}>{data.qty_9}</td>
                          <td style={{ textAlign: "right" }}>{data.qty_10}</td>
                          <td style={{ textAlign: "right" }}>{data.qty_11}</td>
                          <td style={{ textAlign: "right" }}>{data.qty_12}</td>
                          <td style={{ textAlign: "right" }}>{data.qty_13}</td>
                          <td style={{ textAlign: "right" }}>{data.qty_14}</td>
                          <td style={{ textAlign: "right" }}>{data.qty_15}</td>
                          <td style={{ textAlign: "right" }}>{data.qty_16}</td>
                          <td style={{ textAlign: "right" }}>
                            {data.total_qty}
                          </td>
                          {/* {data.allocation_data?.map((item, i) => (
                          <td key={i}>{item.value}</td>
                        ))} */}
                          {/* {allocationValues.map((val, i) => (
                          <td
                            className={`${
                              val > 0 || val < 0 ? "bold-title" : ""
                            }`}
                            key={i}
                            style={{
                              textAlign: "right",
                              color: val < 0 ? "red" : "inherit",
                            }}
                          >
                            {val}
                          </td>
                        ))} */}
                          {allocationGroups.map((g, gi) => (
                            <React.Fragment key={gi}>
                              {g.values
                                ?.filter((v) => v.key !== "Total")
                                .map((v, i) => (
                                  <td
                                    key={i}
                                    className={`${v.value > 0 || v.value < 0
                                      ? "bold-title"
                                      : ""
                                      }`}
                                    style={{
                                      textAlign: "right",
                                      color: v.value < 0 ? "red" : "inherit",
                                    }}
                                  >
                                    {v.value}
                                  </td>
                                ))}

                              {/* TOTAL */}
                              <td
                                style={{
                                  textAlign: "right",
                                  fontWeight: "bold",
                                  color:
                                    g.values?.find((v) => v.key === "Total")
                                      ?.value < 0
                                      ? "red"
                                      : "inherit",
                                }}
                              >
                                {g.values?.find((v) => v.key === "Total")
                                  ?.value || 0}
                              </td>

                              {/* EMPTY CELL (your requirement) */}
                              <td></td>
                            </React.Fragment>
                          ))}
                        </tr>
                        {/* ORDER SEPARATOR */}
                        {isLastRowOfOrder && (
                          <tr>
                            <td
                              colSpan={41 + maxAllocationColumns + 2}
                              style={{
                                height: "12px",
                                background: "#dcdcdc",
                                border: "none",
                              }}
                            ></td>
                          </tr>
                        )}

                        {/* TOTAL */}
                        {/* <tr>
                        <td colSpan="14"></td>

                        <td className="font-weig">Total Quantity</td>

                        <td
                          className="font-weig"
                          style={{ textAlign: "right" }}
                        >
                          {totalQuantity}
                        </td>

                        <td></td>

                        <td style={{ textAlign: "right" }}>${discount}</td>

                        <td style={{ textAlign: "right" }}>
                          ${numeral(amount).format("0,00,0")}
                        </td>

                        <td style={{ textAlign: "right" }}>${tax}</td>

                        <td></td>

                        <td></td>

                        <td style={{ textAlign: "right" }}>{qty1}</td>
                        <td style={{ textAlign: "right" }}>{qty2}</td>
                        <td style={{ textAlign: "right" }}>{qty3}</td>
                        <td style={{ textAlign: "right" }}>{qty4}</td>
                        <td style={{ textAlign: "right" }}>{qty5}</td>
                        <td style={{ textAlign: "right" }}>{qty6}</td>
                        <td style={{ textAlign: "right" }}>{qty7}</td>
                        <td style={{ textAlign: "right" }}>{qty8}</td>
                        <td style={{ textAlign: "right" }}>{qty9}</td>
                        <td style={{ textAlign: "right" }}>{qty10}</td>
                        <td style={{ textAlign: "right" }}>{qty11}</td>
                        <td style={{ textAlign: "right" }}>{qty12}</td>
                        <td style={{ textAlign: "right" }}>{qty13}</td>
                        <td style={{ textAlign: "right" }}>{qty14}</td>
                        <td style={{ textAlign: "right" }}>{qty15}</td>
                        <td style={{ textAlign: "right" }}>{qty16}</td>
                        {allocationHeaders.map((_, i) => (
                          <td key={i}></td>
                        ))}
                      </tr> */}
                      </tbody>
                    </table>
                  </div>
                );
              })
            ) : (
              <div className="no-Data">
                <h1>No Data</h1>
              </div>
            )
          ) : (
            loading && (
              <div className="loader" style={{ marginTop: "20px" }}>
                <Spin size="medium" />
              </div>
            )
          )}
        </div>
        <Modal
          title="Pending Orders"
          visible={isModalOpen}
          onCancel={() => setIsModalOpen(false)}
          footer={null}
          width={900}
        >
          <Table
            columns={columns}
            dataSource={pendingOrders?.map((item, index) => ({
              ...item,
              key: index,
            }))}
            pagination={{ pageSize: 5 }}
            scroll={{ x: true }}
          />
        </Modal>
      </div>
    </>
  );
};

export default MonthWiseAvailability;
